import { MDBCol, MDBRow } from "mdb-react-ui-kit";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import axiosGet from "../../helpers/axiosGet";

import { useParams } from "react-router-dom";
import DataTableClaimRecon from "../../components/DataTable/DataTableClaimRecon";
import SearchForm from "../../components/Form/SearchForm";
import Heading from "../../components/Heading/Heading";
import ScrollToHere from "../../components/ScrollToHere";
import {
  resetListClaimRecon,
  setDataSearchListClaimRecon,
} from "../../store/claim-recon/actions";

export default function History() {
  const dispatch = useDispatch();
  const { uniqId } = useParams();

  //state
  const [reconData, setReconData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [totalPage, setTotalPage] = useState(0);

  const dataSearchListClaimRecon = useSelector(
    (state) => state.claimReconStore.dataSearchListClaimRecon
  );

  const [dataAttachment, setDataAttachment] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(false);
    sessionStorage.setItem("uniqId", uniqId);

    axiosGet({
      url: `/claim-recon/attachment/${uniqId}`,
      callback: (res) => {
        setDataAttachment(res?.data);
        setLoading(false);
      },
      errorCallback: (err) => {
        setLoading(false);
        setError(err);
      },
    });
  }, [uniqId]);

  useEffect(() => {
    if (!dataAttachment?.detail?.[0]?.claimReconAttachmentId) return;

    setLoading(true);
    setError(false);

    const convertDataSearchToUrlParam = (paramsObject) => {
      const params = new URLSearchParams(paramsObject);
      return params.toString();
    };

    axiosGet({
      url: `/claim-recon/attachment/detail/page/${
        dataSearchListClaimRecon.storedPage
      }?${convertDataSearchToUrlParam({
        claimReconAttachmentId: dataAttachment.detail[0].claimReconAttachmentId,
        ...dataSearchListClaimRecon.storedValues,
      })}`,
      callback: (resp) => {
        setReconData(resp.data.data);
        setTotalPage(resp.data.totalPage);
        setLoading(false);
      },
      errorCallback: (err) => {
        setLoading(false);
        setError(err);
      },
    });
  }, [
    dataAttachment,
    dataSearchListClaimRecon.storedPage,
    dataSearchListClaimRecon.storedValues,
  ]);

  const handleSearch = (data) => {
    ScrollToHere();
    dispatch(
      setDataSearchListClaimRecon({
        storedValues: data,
        storedPage: 1,
      })
    );
  };

  const handleReset = () => {
    ScrollToHere();
    dispatch(resetListClaimRecon());
  };

  const handlePage = (value) => {
    ScrollToHere();

    let newPage = value.selected + 1;

    dispatch(
      setDataSearchListClaimRecon({
        ...dataSearchListClaimRecon,
        storedPage: newPage,
      })
    );
  };

  const inputs = [
    {
      name: "noClaim",
      label: "Claim Number",
      type: "text",
    },
    {
      name: "refId",
      label: "Policy Certificate Number",
      type: "text",
    },
    {
      name: "insurer",
      label: "Insurer",
      type: "text",
    },
    {
      name: "product",
      label: "Product",
      type: "text",
    },
    {
      name: "maxSumInsured",
      label: "Max Sum Insured",
      type: "text",
    },
    {
      name: "minSumInsured",
      label: "Min Sum Insured",
      type: "text",
    },
    {
      name: "maxNetPremium",
      label: "Max Premium",
      type: "text",
    },
    {
      name: "minNetPremium",
      label: "Min Premium",
      type: "text",
    },
    {
      name: "minExpiredDate",
      label: "Min Expired Date",
      type: "date",
    },
    {
      name: "maxExpiredDate",
      label: "Max Expired Date",
      type: "date",
    },
    {
      name: "minClaimLastUpdateDate",
      label: "Min Claim Last Update Date",
      type: "date",
    },
    {
      name: "maxClaimLastUpdateDate",
      label: "Max Claim Last Update Date",
      type: "date",
    },
  ];

  const headers = [
    {
      name: (
        <>
          <div>Claim Number</div>
          <div>Policy Certificate Number</div>
        </>
      ),
    },
    {
      name: (
        <>
          <div>Insurer</div>
          <div>Product</div>
        </>
      ),
    },
    {
      name: (
        <>
          <div>Sum Insured</div>
          <div>Premium</div>
        </>
      ),
    },
    {
      name: (
        <>
          <div>Claim Amount</div>
          <div>Final Amount</div>
        </>
      ),
    },
    {
      name: (
        <>
          <div>Latest Status</div>
          <div>Deadline</div>
          <div>Last Update Date</div>
        </>
      ),
    },
    {
      name: "Detail",
    },
  ];

  return (
    <>
      <Heading>
        {dataAttachment?.companyName}
        <br />
        {dataAttachment?.period}
      </Heading>

      <section className="overflow-hidden">
        <MDBRow className="g-4">
          {loading ? (
            <div className="d-flex align-items-center justify-content-center">
              Loading...
            </div>
          ) : error && error?.response?.status === 403 ? (
            <MDBCol md="12">
              <div
                className="mt-2 mb-2 d-flex justify-content-center align-items-center"
                style={{ minHeight: "200px" }}
              >
                <p className="text-center text-danger">
                  Link sudah kadaluwarsa. <br />
                  Silakan hubungi WhatsApp berikut:{" "}
                  <a
                    href="https://api.whatsapp.com/send/?phone=6285157882496"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span>(+62 851-5788-2496)</span>
                  </a>{" "}
                  untuk informasi lebih lanjut
                </p>
              </div>
            </MDBCol>
          ) : (
            <>
              <MDBCol md="12">
                <SearchForm
                  inputs={inputs}
                  handleSearch={handleSearch}
                  handleReset={handleReset}
                  defVals={dataSearchListClaimRecon.storedValues}
                />
              </MDBCol>

              <MDBCol md="12">
                <DataTableClaimRecon
                  rows={reconData}
                  headers={headers}
                  loading={loading}
                  error={error}
                  handleScroll={ScrollToHere}
                  page={dataSearchListClaimRecon.storedPage}
                  totalPage={totalPage}
                  handlePage={handlePage}
                />
              </MDBCol>
            </>
          )}
        </MDBRow>
      </section>
    </>
  );
}
